export const UPDATE_SELECTED_GIFS = 'UPDATE_SELECTED_GIFS'
export const LOAD_GIF_DATA_SUCCESS = 'LOAD_GIF_DATA_SUCCESS'

export const UPDATE_SEACH_QUERY = 'UPDATE_SEACH_QUERY'
export const SET_LOAD_ERROR = 'SET_LOAD_ERROR'
export const SET_NUMBER_OF_AJAX_CALLS = 'SET_NUMBER_OF_AJAX_CALLS'



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js